import React, { useState } from "react";
import { postRequest } from "../../api/ApiInstance";

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [subject, setSubject] = useState('');
  const [desc, setDesc] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = 'कृपया अपना पूरा नाम दर्ज करें।';
    } else if (name.trim().length < 3) {
      newErrors.name = 'नाम कम से कम 3 अक्षरों का होना चाहिए।';
    }

    if (!email.trim()) {
      newErrors.email = 'कृपया अपना ईमेल पता दर्ज करें।';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim())) {
      newErrors.email = 'कृपया एक मान्य ईमेल पता दर्ज करें।';
    }

    const digits = mobile.replace(/\D/g, '');
    if (!mobile.trim()) {
      newErrors.mobile = 'कृपया अपना मोबाइल नंबर दर्ज करें।';
    } else if (digits.length !== 10) {
      newErrors.mobile = 'मोबाइल नंबर ठीक 10 अंकों का होना चाहिए।';
    } else if (!/^[6-9]/.test(digits)) {
      newErrors.mobile = 'मोबाइल नंबर 6-9 से शुरू होना चाहिए।';
    }

    if (!subject) {
      newErrors.subject = 'कृपया एक विषय चुनें।';
    }

    if (!desc.trim()) {
      newErrors.desc = 'कृपया अपना संदेश दर्ज करें।';
    } else if (desc.trim().length < 10) {
      newErrors.desc = 'संदेश कम से कम 10 अक्षरों का होना चाहिए।';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus(null);
    if (!validateForm()) {
      return;
    }
    setIsSubmitting(true);
    try {
      const data = await postRequest('/contactus', {
        full_name: name,
        email,
        mobile,
        subject,
        message: desc
      });

      console.log(data);
      setSubmitStatus('success');

      // form clear
      setName('');
      setEmail('');
      setMobile('');
      setSubject('');
      setDesc('');

      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error(error?.response?.data || error.message);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-0">
      {/* Hero Section */}
      <div className="bg-brand-purple text-white py-12 md:py-20 mt-[-1px]">
        <div className="max-w-7xl mx-auto px-4 flex flex-col items-center justify-center text-center">
          <span className="text-purple-200 font-bold tracking-[0.2em] uppercase text-sm mb-4">
            हमें आपसे सुनना अच्छा लगेगा
          </span>
          <h1 className="text-4xl md:text-6xl font-black tracking-tight drop-shadow-md mb-4">
            संपर्क करें
          </h1>
          <p className="max-w-2xl text-red-100 text-lg md:text-xl font-medium">
            चाहे आपके पास कोई न्यूज़ टिप हो, विज्ञापन संबंधी पूछताछ हो, या सामान्य प्रतिक्रिया हो, हमारी टीम जुड़ने के लिए तैयार है।
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 -mt-10 relative z-30 mb-16">
        <div className="bg-white rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.1)] overflow-hidden flex flex-col lg:flex-row border border-gray-100">
          
          {/* Left Column: Contact Info */}
          <div className="lg:w-2/5 bg-brand-red p-10 md:p-14 text-white relative overflow-hidden">
            <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 rounded-full bg-white/10 blur-3xl"></div>
            <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-64 h-64 rounded-full bg-black/10 blur-3xl"></div>
            
            <div className="relative z-10">
              <h2 className="text-3xl font-bold mb-2">संपर्क जानकारी</h2>
              <p className="text-red-100 mb-12">
                फॉर्म भरें और हमारी टीम 24 घंटे के भीतर आपसे संपर्क करेगी।
              </p>

              <div className="space-y-10">
                <div className="flex items-start gap-6 group">
                  <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0 group-hover:bg-white transition-colors duration-300">
                    <i className="fa-solid fa-phone text-white text-xl group-hover:text-brand-red transition-colors"></i>
                  </div>
                  <div>
                    <h4 className="text-sm text-red-200 font-medium mb-1 uppercase tracking-wider">फोन</h4>
                    <a href="tel:+919755724915" className="text-lg font-semibold hover:text-gray-200 transition-colors">
                      +91 97557 24915
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-6 group">
                  <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0 group-hover:bg-white transition-colors duration-300">
                    <i className="fa-solid fa-envelope text-white text-xl group-hover:text-brand-red transition-colors"></i>
                  </div>
                  <div>
                    <h4 className="text-sm text-red-200 font-medium mb-1 uppercase tracking-wider">ईमेल</h4>
                    <a href="mailto:info@mandakinitimes.com" className="text-lg font-semibold hover:text-gray-200 transition-colors">
                      info@mandakinitimes.com
                    </a>
                    <p className="text-red-100 text-sm mt-1">संपादकीय और विज्ञापनों के लिए</p>
                  </div>
                </div>

                <div className="flex items-start gap-6 group">
                  <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0 group-hover:bg-white transition-colors duration-300">
                    <i className="fa-solid fa-location-dot text-white text-xl group-hover:text-brand-red transition-colors"></i>
                  </div>
                  <div>
                    <h4 className="text-sm text-red-200 font-medium mb-1 uppercase tracking-wider">कार्यालय</h4>
                    <p className="text-lg font-semibold leading-relaxed">
                      द मंदाकिनी टाइम्स कार्यालय<br />
                      <span className="text-red-50 text-base font-normal">
                        Badi bagrajan mata asaram bapu asmam ke pichea<br />
                        govind siti<br />
                        Chhatarpur, Madhya Pradesh
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Contact Form */}
          <div className="lg:w-3/5 p-10 md:p-14 bg-white">
            <h3 className="text-3xl font-bold text-gray-900 mb-8">हमें संदेश भेजें</h3>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">पूरा नाम <span className="text-purple-500">*</span></label>
                  <input
                    type="text"
                    required
                    value={name}
                    placeholder="आपका नाम"
                    className={`w-full bg-gray-50 text-gray-900 rounded-xl px-4 py-3.5 outline-none focus:ring-2 focus:ring-red-500/20 focus:border-purple-500 transition-all duration-300 ${errors.name ? 'border border-red-500' : 'border border-gray-200'}`}
                    onChange={(e) => setName(e.target.value)}
                  />
                  {errors.name && <p className="text-sm text-red-500 font-medium">{errors.name}</p>}
                </div>
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">ईमेल पता <span className="text-purple-500">*</span></label>
                  <input
                    type="email"
                    required
                    value={email}
                    placeholder="name@example.com"
                    className={`w-full bg-gray-50 text-gray-900 rounded-xl px-4 py-3.5 outline-none focus:ring-2 focus:ring-red-500/20 focus:border-purple-500 transition-all duration-300 ${errors.email ? 'border border-red-500' : 'border border-gray-200'}`}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors.email && <p className="text-sm text-red-500 font-medium">{errors.email}</p>}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">मोबाइल नंबर <span className="text-purple-500">*</span></label>
                  <input
                    type="tel"
                    required
                    inputMode="numeric"
                    maxLength={10}
                    value={mobile}
                    placeholder="9876543210"
                    className={`w-full bg-gray-50 text-gray-900 rounded-xl px-4 py-3.5 outline-none focus:ring-2 focus:ring-red-500/20 focus:border-purple-500 transition-all duration-300 ${errors.mobile ? 'border border-red-500' : 'border border-gray-200'}`}
                    onChange={(e) => setMobile(e.target.value.replace(/\D/g, '').slice(0, 10))}
                  />
                  {errors.mobile && <p className="text-sm text-red-500 font-medium">{errors.mobile}</p>}
                </div>
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">विषय <span className="text-purple-500">*</span></label>
                  <div className="relative">
                    <select 
                      required
                      value={subject}
                      className={`w-full bg-gray-50 text-gray-900 rounded-xl px-4 py-3.5 outline-none focus:ring-2 focus:ring-red-500/20 focus:border-purple-500 transition-all duration-300 appearance-none ${errors.subject ? 'border border-red-500' : 'border border-gray-200'}`} 
                      onChange={(e) => setSubject(e.target.value)}
                    >
                      <option value="" disabled>एक विषय चुनें</option>
                      <option value="News Tip">न्यूज़ टिप</option>
                      <option value="Correction / Complaint">सुधार / शिकायत</option>
                      <option value="Advertisement">विज्ञापन</option>
                      <option value="Career / Internship">करियर / इंटर्नशिप</option>
                      <option value="General Feedback">सामान्य प्रतिक्रिया</option>
                    </select>
                    {errors.subject && <p className="text-sm text-red-500 font-medium">{errors.subject}</p>}
                    <div className="absolute inset-y-0 right-0 flex items-center px-4 pointer-events-none">
                      <i className="fa-solid fa-chevron-down text-gray-400"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <label className="text-sm font-semibold text-gray-700">संदेश <span className="text-purple-500">*</span></label>
                <textarea
                  required
                  rows="5"
                  value={desc}
                  placeholder="अपना संदेश यहाँ लिखें..."
                  className={`w-full bg-gray-50 text-gray-900 rounded-xl px-4 py-3.5 outline-none focus:ring-2 focus:ring-red-500/20 focus:border-purple-500 transition-all duration-300 resize-none ${errors.desc ? 'border border-red-500' : 'border border-gray-200'}`}
                  onChange={(e) => setDesc(e.target.value)}
                ></textarea>
                {errors.desc && <p className="text-sm text-red-500 font-medium">{errors.desc}</p>}
              </div>

              {submitStatus === 'success' && (
                <div className="p-4 bg-green-50 border border-green-200 rounded-xl flex items-center gap-3 text-green-700">
                  <i className="fa-solid fa-circle-check text-xl"></i>
                  <p className="font-medium">आपका संदेश सफलतापूर्वक भेज दिया गया है! हम जल्द ही आपसे संपर्क करेंगे।</p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="p-4 bg-purple-50 border border-red-200 rounded-xl flex items-center gap-3 text-red-700">
                  <i className="fa-solid fa-circle-exclamation text-xl"></i>
                  <p className="font-medium">संदेश भेजने में विफल। कृपया बाद में पुनः प्रयास करें।</p>
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-purple-700 hover:text-brand-red text-white py-4 rounded-xl font-bold text-lg transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg disabled:opacity-70 disabled:hover:translate-y-0 disabled:hover:shadow-none flex justify-center items-center gap-2"
              >
                {isSubmitting ? (
                  <>
                    <i className="fa-solid fa-circle-notch fa-spin"></i>
                    भेजा जा रहा है...
                  </>
                ) : (
                  <>
                    संदेश भेजें
                    <i className="fa-solid fa-paper-plane text-sm"></i>
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className="w-full">
        <div className="w-full h-[450px]">
          <iframe
            title="Office Location Map"
            className="w-full h-full border-0"
            src="https://www.google.com/maps?q=24.932909,79.6006851&z=16&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

    </div>
  );
};

export default Contact;
